import { createFileRoute } from '@tanstack/react-router'
import { MaioresAtestadores } from '@/features/maiores-atestadores'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/maiores-atestadores/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: MaioresAtestadores,
})
